import { useState, useEffect } from "react";
import {
  auth,
  subscribeToAuthChanges,
  loginWithGoogle,
  logoutUser,
  setupRecaptcha,
  sendPhoneOTP,
  verifyPhoneOTP,
  signUpWithEmail,
  signInWithEmail,
  type User,
  type ConfirmationResult,
} from "@/lib/firebase";

export function useAuth() {
  const [user, setUser] = useState<User | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  useEffect(() => {
    const unsubscribe = subscribeToAuthChanges((firebaseUser) => {
      setUser(firebaseUser);
      setIsLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const login = async () => {
    try {
      await loginWithGoogle();
    } catch (error) {
      console.error("Login failed:", error);
      throw error;
    }
  };

  const logout = async () => {
    try {
      setIsLoggingOut(true);
      await logoutUser();
    } catch (error) {
      console.error("Logout failed:", error);
      throw error;
    } finally {
      setIsLoggingOut(false);
    }
  };

  return {
    user,
    isLoading,
    isAuthenticated: !!user,
    login,
    logout,
    isLoggingOut,
    setupRecaptcha,
    sendPhoneOTP,
    verifyPhoneOTP,
    signUpWithEmail,
    signInWithEmail,
  };
}
